import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import { store } from "./store";
import Home from "./components/ExhibitorList";
import DetailPage from "./components/ExhibitorProfile/ExhibitorProfile";

Vue.config.productionTip = false;
Vue.use(VueRouter);

const routes = [
  {
    name: "home",
    path: "/conferences/strategicspeakers",
    component: Home
  },
  {
    name: "home",
    path: "/conferences/technicalspeakers",
    component: Home
  },
  {
    name: "home",
    path: "/forum-programme/technical-speakers",
    component: Home
  },
  {
    name: "home",
    path: "/forum-programme/2024-speakers",
    component: Home
  },
  {
    name: "SpeakerDetails",
    path: "/speakerdetails",
    component: DetailPage
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior() {
    // always scroll to top
    return { x: 0, y: 0 };
  }
});

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");
